import ChatList from 'modules/chat/chatList';
import {useEffect} from 'react';

import useGetChatted from './hooks/useGetChatted';
import useDeleteChat from './hooks/useDeleteChat';
import Header from 'modules/header/farm/home';

import DotsLoading from 'components/loadings/dotsLoading';
import {useCookies} from 'react-cookie';
import EmptyPost from 'assets/images/emptyPage/empty page.svg';

const ChatsContainer = () => {
  const [, , removeCookie] = useCookies(['cultivationGuid']);
  useEffect(() => {
    removeCookie('cultivationGuid', {
      path: '/',
      domain: 'mazraeapp.com',
    });
  }, []);
  const {userChatData, userChatDataIsloading, refetch} = useGetChatted({
    app: 'FARM',
  });
  const {mutate} = useDeleteChat({refetch});
  return (
    <>
      <div className="flex flex-col w-full h-full gap-4">
        <Header />
        <div className="flex flex-col h-[91%]">
          {userChatDataIsloading ? (
            <DotsLoading />
          ) : userChatData?.results.length === 0 ? (
            <div className=" mt-28">
              <img src={EmptyPost} alt="empty" className=" block mx-auto" />
              <p className=" text-gray-5 text-center">
                موردی برای نمایش وجود ندارد.
              </p>
            </div>
          ) : (
            <ChatList
              chats={userChatData?.results}
              optionsChatItem={[
                {
                  icon: <div className="icon-trash text-[18px]" />,
                  action: id => mutate(id),
                  title: 'حذف',
                },
              ]}
            />
          )}
        </div>
      </div>
    </>
  );
};

export default ChatsContainer;
